import { render } from "./CorteVentas.vue?vue&type=template&id=c4cbef68"
import script from "./CorteVentas.vue?vue&type=script&lang=js"
export * from "./CorteVentas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__